/**
 * Einzahl und Mehrzahl im Deutschen brauchen oft auch ein anderes Verb.
 * Deshalb werden ganze Wortgruppen uebergeben, nicht nur Substantive:
 *
 *   plural(1, 'Zugang hängt', 'Zugänge hängen')  ->  "1 Zugang hängt"
 *   plural(4, 'Zugang hängt', 'Zugänge hängen')  ->  "4 Zugänge hängen"
 */
export function plural(count: number, one: string, many: string): string {
  return `${count} ${count === 1 ? one : many}`;
}
